import React, { useState } from "react";
import { Link } from "react-router-dom";
import Goods from "./goods";
import Stock from "./stock";
import Vendor from "./vendor";
import Product from "./product";
import ProductCategory from "./productCategory";

const InventoryTabs = () => {

    const [activeTab, setActiveTab] = useState("Issue / Return Goods");

    const tabData = [
        {
            icon: <i className="fas fa-truck" />,
            name: "Issue / Return Goods",
            content: <Goods />
        },
        {
            icon: <i className="fas fa-warehouse" />,
            name: "Stock",
            content: <Stock />
        },
        {
            icon: <i className="fas fa-industry" />,
            name: "Vendors",
            content: <Vendor />
        },
        {
            icon: <i className="fas fa-cubes" />,
            name: "Products",
            content: <Product />
        },
        {
            icon: <i className="fas fa-box" />,
            name: "Product Category",
            content: <ProductCategory />
        }
    ]
    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">Inventory</h3>
                            </div>
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link
                                                        to="#"
                                                        className={tab.name === activeTab ? "active" : ""}
                                                        onClick={() => setActiveTab(tab.name)}
                                                    >
                                                        {tab.icon} {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {tabData
                                        .filter(tab => tab.name === activeTab)
                                        .map((tab, i) => (
                                            <div key={i}>{tab.content}</div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InventoryTabs;